var exports = {
  "r": "ActiveNowTab.module__cooldownHint___VjhfeF",
};

module.exports = exports;
